import { render, staticRenderFns } from "./helpful.vue?vue&type=template&id=be9dffe4&scoped=true"
import script from "./helpful.vue?vue&type=script&lang=js"
export * from "./helpful.vue?vue&type=script&lang=js"
import style0 from "./helpful.vue?vue&type=style&index=0&id=be9dffe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9dffe4",
  null
  
)

export default component.exports